import React from 'react';
import { Project, ProjectPlanStep, ProjectActivityTimeline, ProjectKnowledgeBase } from '../../types';
import ProjectOverview from './ProjectOverview';

interface ProjectHomeProps {
  project: Project;
  planSteps: ProjectPlanStep[];
  activities: ProjectActivityTimeline[];
  knowledge: ProjectKnowledgeBase[];
}

const ProjectHome: React.FC<ProjectHomeProps> = ({
  project,
  planSteps = [],
  activities = [],
  knowledge = [],
}) => {
  return (
    <div className="flex-1 flex flex-col h-full overflow-hidden font-sans">
      <div className="flex-1 flex flex-col overflow-hidden">
        <ProjectOverview 
          project={project} 
          planSteps={planSteps}
          activities={activities}
          knowledge={knowledge}
        />
      </div>
    </div>
  );
};

export default ProjectHome;
